import { MooringArticleProduct } from './MooringArticleProduct';
import { MooringArticleMaterial } from './MooringArticleMaterial';
import { CategoryDimensionType } from './MooringArticleCategory';
import { CertificateProducer } from './MooringSupplier';
import { MooringCategoryType } from './MooringArticleCategoryType';
import { ArticleTypeVariant } from './MooringArticleType';
import { ErpSystem } from 'models/ErpSystem';

export class CreateMooringArticle {
  static ApiUrl = 'api/mooring-articles';
  Id?: number;
  CategoryId!: number;
  TypeId!: number;
  ProductTypeId?: number;
  SupplierId!: number;
  OverrideCertificateProducer?: CertificateProducer;
  WeightInAir?: number;
  WeightInWater?: number;
  PrimaryDimension!: number;
  SecondaryDimension?: number;
  CriteriaForValidityCategoryId?: number;
  ArticleProducts?: {
    Id: number;
    ProductId: number;
    ProductSource?: number;
    MooringArticleId: number;
  }[];
  MooringArticleMaterials?: MooringArticleMaterial[];
  MBL?: number;
  WLL?: number;
  UnitSize!: number;
  Inactive!: boolean;
}

export class CheckDuplicateMooringArticleProduct {
  Id!: number;
  MooringArticleId!: number;
  ProductId!: number;
  SupplierId!: number;
  MooringArticleCategoryId!: number;
  MooringArticleTypeId!: number;
  MooringArticleProductTypeId!: number;
}

export class MooringArticle {
  static ApiUrl = 'api/mooring-articles';
  Id!: number;
  CategoryId!: number;
  CategoryName!: string;
  TypeId!: number;
  TypeName!: string;
  ProductTypeId?: number;
  ProductTypeName!: string;
  SupplierId!: number;
  SupplierName!: string;
  OverrideCertificateProducer!: CertificateProducer;
  ArticleProducts!: MooringArticleProduct[];
  MBL?: number;
  WLL?: number;
  UnitSize!: number;
  WeightInAir?: number;
  WeightInWater?: number;
  PrimaryDimension!: number;
  PrimaryDimensionType!: CategoryDimensionType;
  SecondaryDimension?: number;
  SecondaryDimensionType?: CategoryDimensionType;
  Inactive!: boolean;
  CriteriaForValidityCategoryId?: number;
  MooringArticleMaterials?: MooringArticleMaterial[];
  HasCertificate!: boolean;
  HasApprovedCertificate!: boolean;
}

export class MooringArticleListItem {
  static ApiUrl = 'api/mooring-articles/items';
  Id!: number;
  Category!: string;
  Type!: string;
  ProductType!: string;
  ArticleNumbers!: string[];
  Supplier!: string;
  MBL!: number;
  PrimaryDimension!: number;
  PrimaryDimensionType!: CategoryDimensionType;
  SecondaryDimension?: number;
  SecondaryDimensionType?: CategoryDimensionType;

  CategoryType!: MooringCategoryType;
  ErpSystem!: ErpSystem;
  TypeVariant!: ArticleTypeVariant;
}

export class MooringArticleSearchResult {
  Id!: number;
  Name!: string;
  ArticleNumber!: string;
  ArticleProductId!: number;

  CategoryType!: MooringCategoryType;
  TypeVariant!: ArticleTypeVariant;

  Category!: string;
  Type!: string;
  Supplier!: string;
  ProductType!: string;
  MBL?: number;
  PrimaryDimension!: number;
  SecondaryDimension?: number;
}
